// Core
import { Route, Switch, Redirect, useRouteMatch, useHistory, useLocation } from 'react-router-dom';
import { useState, useMemo } from 'react';
import { Box } from '@chakra-ui/react';

// Components
import LargeScale from './components/LargeScale';
import Giveaway from './Giveaway';
import PreviousWinners from './components/PreviousWinners';
import Daily from './components/Daily';
import Upcoming from './components/Upcoming';
import ButtonSelector from 'components/ButtonSelector/ButtonSelector';

const Giveaways = ({ userData }) => {
  const { path } = useRouteMatch();

  const [tab, setTab] = useState('upcoming');

  const location = useLocation();
  const isGiveawayPage = /^\/giveaways\/\d+$/.test(location.pathname);

  return (
  	<>
    	{!isGiveawayPage && <LargeScale />}

      {!isGiveawayPage && (
        <ButtonSelector
          buttons={
            [
              { key: 'upcoming', name: 'Upcoming' },
              { key: 'winners', name: 'Winners' },
              { key: 'daily', name: 'Daily' },
            ]
          }
          selected={tab}
          onSelect={setTab}
          w={{ base: '100%', md: '361px' }}
          m={{ base: '60px auto 0 auto', md: '80px auto 0 auto' }}
        />
      )}

    	<Box my={{base: '24px', md: '40px'}} >
		    <Switch>
          <Route path={`${path}/:id`}  render={() => <Giveaway userData={userData} />} />
			    <Route path="/giveaways" render={() => (
            tab === 'upcoming' ? <Upcoming userData={userData} />
            : tab === 'daily' ? <Daily userData={userData} /> 
            : <PreviousWinners userData={userData} />
          )} />
			    <Redirect from={`${path}*`} to={`${path}`} />
			  </Switch>
		  </Box>
	  </>
  );
};

export default Giveaways;